<template>
    <div>
        <div class="background container-edit" v-if="photo != null">
            <div id="canvas-container" @click="detectDoubleTap">
                <img ref="photo" id="photo" class="img" alt="Imagem aqui." />
                <canvas ref="canvasPhoto" id="canvas-photo">Canvas não disponível</canvas>
                <div class="m-0 h4 photo-name" style="color: #ccf195; text-align: center;">
                    {{ photo.photoName }}
                </div>
            </div>

            <div class="container-buttons" id="container-buttons">
                <b-button
                    v-b-modal.modal-2
                    class="mt-3 buttons"
                    type="button"
                    :variant="brushColor"
                    >Cor</b-button
                >
                <b-button
                    class="mt-3 buttons"
                    id="eraser"
                    type="button"
                    variant="primary"
                    @click="clearCanvas"
                    >Apagar</b-button
                >
                <b-button
                    class="mt-3 buttons"
                    type="button"
                    variant="success"
                    @click="savePhoto"
                    >Salvar</b-button
                >
            </div>

            <b-modal
                ref="modalBrush"
                id="modal-2"
                title="Selecione a cor"
                @hide="changeBrushColor()"
                hide-footer
                hide-header-close
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <b-button
                            class="mt-2"
                            variant="red"
                            type="button"
                            @click="
                                brushColor = 'red';
                                $refs['modalBrush'].hide();
                            "
                            >Vermelho</b-button
                        >
                        <b-button
                            class="mt-2"
                            variant="green"
                            type="button"
                            @click="
                                brushColor = 'green';
                                $refs['modalBrush'].hide();
                            "
                            >Verde</b-button
                        >
                        <b-button
                            class="mt-2"
                            variant="yellow"
                            type="button"
                            @click="
                                brushColor = 'yellow';
                                $refs['modalBrush'].hide();
                            "
                            >Amarelo</b-button
                        >
                        <b-button
                            class="mt-2"
                            variant="blue"
                            type="button"
                            @click="
                                brushColor = 'blue';
                                $refs['modalBrush'].hide();
                            "
                            >Azul</b-button
                        >
                        <b-button
                            variant="purple"
                            class="mt-2"
                            type="button"
                            @click="
                                brushColor = 'purple';
                                $refs['modalBrush'].hide();
                            "
                            >Roxo</b-button
                        >
                    </div>
                </div>
            </b-modal>

            <b-button
                v-b-modal.modal-1
                style="display: none"
                id="modal-button"
            ></b-button>

            <b-modal
                ref="modalIcon"
                id="modal-1"
                title="Selecione o Tipo"
                @hide="paintIcon()"
                hide-footer
                hide-header-close
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <b-button
                            variant="red"
                            style=""
                            id="pencil"
                            type="button"
                            @click="selectIcon('amassado')"
                            >Amassado</b-button
                        >
                        <b-button
                            variant="purple"
                            class="mt-3"
                            id="pencil"
                            type="button"
                            @click="selectIcon('pique')"
                            >Pique</b-button
                        >
                        <b-button
                            variant="yellow"
                            class="mt-3"
                            id="pencil"
                            type="button"
                            @click="selectIcon('quebrado')"
                            >Quebrado</b-button
                        >
                        <b-button
                            variant="blue"
                            class="mt-3"
                            id="pencil"
                            type="button"
                            @click="selectIcon('riscado')"
                            >Riscado</b-button
                        >
                        <b-button
                            variant="green"
                            class="mt-3"
                            id="pencil"
                            type="button"
                            @click="selectIcon('trincado')"
                            >Trincado</b-button
                        >
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { BButton, BModal, VBModal } from "bootstrap-vue";
import Swal from "sweetalert2";

import SignaturePad from "signature_pad";

import calcBase64Size from "@/utils/calcBase64Size";

export default {
    props: {
        photo: Object,
    },
    components: {
        BButton,
        BModal
    },
    directives: {
        "b-modal": VBModal
    },
    data: function () {
        return {
            tool: "pencil",
            screenWidth: null,
            screenHeight: null,
            icon: new Image(),
            context: null,
            canvas: null,
            image: null,
            mousePos: {},
            selectedIcon: null,
            signaturePad: null,
            brushColor: "red",
            contador: 0,
            dcTimeout: null,
            tappedOnce: false,
            photoToImgRatio: 1
        };
    },

    methods: {
        detectDoubleTap: function (e) {
            e.preventDefault();
            if (!this.tappedOnce) {
                this.tappedOnce = true;
                this.dcTimeout = setTimeout(() => {
                    this.tappedOnce = false;
                }, 450);
            } else {
                clearTimeout(this.dcTimeout);
                this.tappedOnce = false;
                this.showModal(e);
            }
        },

        setCanvas: function (saveState = false) {
            const canvasPhoto = this.$refs.canvasPhoto;
            let context = canvasPhoto.getContext("2d");
            let imageData = null;
            if(saveState){
                imageData = context.getImageData(0, 0, canvasPhoto.width, canvasPhoto.height);
            }

            canvasPhoto.width = this.imageWidth;
            canvasPhoto.height = this.imageHeight;
            
            context.scale(this.photoToImgRatio, this.photoToImgRatio);
            if(saveState) {
                context.putImageData(imageData, 0, 0);
            }
        },

        changeBrushColor() {
            this.signaturePad.penColor = this.brushColor;
        },

        paint() {
            if (!this.signaturePad) {
                try {
                    this.signaturePad = new SignaturePad(this.$refs.canvasPhoto, {
                        penColor: "red",
                        dotSize: 0.1,
                        minWidth: 2.8 / this.photoToImgRatio,
                        maxWidth: 2.8 / this.photoToImgRatio,
                        minDistance: 2
                    });
                } catch (err) {
                    console.error("err:  ", err);
                }
            }
        },

        clearCanvas: function () {
            this.signaturePad.clear();
        },

        savePhoto: function () {
            const canvas = this.$refs.canvasPhoto;
            let image = new Image();
            image.src = this.photo && this.photo.image_base64;
            let newCanvas = document.createElement("canvas");

            let context = newCanvas.getContext("2d");

            context.canvas.width = this.imageWidth;
            context.canvas.height = this.imageHeight;
            context
                .drawImage(image, 0, 0, this.imageWidth, this.imageHeight);
            context
                .drawImage(canvas, 0, 0, this.imageWidth, this.imageHeight);

            const currentDate = new Date();
            const fullDate = currentDate.toLocaleString("pt-BR").replaceAll(",", "");

            context.font = "30px serif";
            context.fillStyle = "red";

            context.fillText(
                this.photo.photoName,
                10,
                this.imageHeight - 50,
                this.imageHeight
            );
            context.fillText(
                fullDate,
                10,
                this.imageHeight - 20,
                this.imageHeight
            );

            let editedPhoto = this.photo;
            editedPhoto.image_base64 = newCanvas.toDataURL("image/jpeg", 0.85);
            editedPhoto.image_size = Math.ceil(calcBase64Size(editedPhoto.image_base64));

            this.$router.push({
                name: "photosGrid",
                params: { takenPhoto: editedPhoto }
            });
        },

        selectIcon: function (iconName) {
            this.selectedIcon = iconName;
            this.$refs["modalIcon"].hide();
        },

        paintIcon: function () {
            if(this.selectedIcon != null){
                const iconPhoto = new URL(`../../../assets/imgs/${this.selectedIcon}.png`, import.meta.url).href;
                const {top, left} = this.$refs.canvasPhoto.getBoundingClientRect();
                const pinWidth = Math.floor(120 / this.photoToImgRatio);
                const pinHeight = Math.floor(120 / this.photoToImgRatio);
                this.signaturePad.fromDataURL(iconPhoto, {
                    width: pinWidth, height: pinHeight,
                    xOffset: this.mousePos.x - left - (Math.floor(pinWidth/2)),
                    yOffset: this.mousePos.y - top - (pinHeight)
                });
                this.selectedIcon = null;
            }
        },

        showModal: function (e) {
            e.preventDefault();
            document.getElementById("modal-button").click();
            this.mousePos.x = e.clientX;
            this.mousePos.y = e.clientY;
        },

        fireOrientationAlert: function() {
            Swal.fire({
                icon: "warning",
                title: "Orientação não suportada",
                text: "Não é possível editar a foto com o dispositivo na horizontal. Por favor, deixe o dispositivo na vertical!",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false
            });
        },
        
        calcImgToWindowRatio() {
            const imgDiagonal = Math.sqrt(this.$refs.photo.scrollWidth * this.$refs.photo.scrollWidth + this.$refs.photo.scrollHeight * this.$refs.photo.scrollHeight);
            const screenDiagonal = Math.sqrt(this.screenWidth * this.screenWidth + this.screenHeight * this.screenHeight);
            return imgDiagonal / screenDiagonal;
        },

        getDeviceOrientation() {
            return window.matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait";
        },

        onResize(saveCanvasState = false) {
            try {
                this.screenWidth = window.innerWidth;
                this.screenHeight = window.innerHeight;
                this.photoToImgRatio = this.imageWidth / this.$refs.photo.offsetWidth;
                if(this.signaturePad) {
                    this.signaturePad.minWidth = 2.8 / this.photoToImgRatio;
                    this.signaturePad.maxWidth = 2.8 / this.photoToImgRatio;
                } else {
                    this.paint();
                }
                this.setCanvas(saveCanvasState);
            } catch (error) {
                console.error(error);
            }
        },

        onResizeSaveState: function (e) {this.onResize(true);},
        onResizeNoSaveState: function (e) {this.onResize(true);}
    },

    created: function () {
        if (!this.photo)
            this.$router.go(-1);
    },

    mounted: function () {
        if (this.photo){
            this.imageWidth = this.$store.state.sizePhoto.width;
            this.imageHeight = this.$store.state.sizePhoto.height;

            this.imageAspectRatio = this.imageWidth / this.imageHeight;
            this.screenWidth = window.innerWidth;
            this.screenHeight = window.innerHeight;

            this.$refs.photo.src = this.photo.image_base64;
            this.$refs.photo.onload = this.onResizeNoSaveState;
    
            window.addEventListener("resize", this.onResizeSaveState);
        }
    },

    beforeDestroy: function () {
        window.removeEventListener("resize", this.onResizeSaveState);
        this.$refs.photo.onload = null;
    },

    beforeRouteLeave(to, from, next) {
        if(to.name === "camera"){
            this.$router.go(-1);
        } else {
            next();
        }
    }
};
</script>

<style lang="scss">
    #modal-2 {
        .modal-dialog {
            max-height: 100%;
            overflow: auto;

        }
    }
</style>

<style scoped lang="scss">

.container-edit {
    position: absolute;
    z-index: 200;
    top: 0;
    height: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
}

#canvas-container {
    flex: 1 1 100%;
    width: fit-content;
    overflow: hidden;
    position: relative;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;

    &> .photo-name {
        width: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
    }
}

.background {
    width: 100vw;
    background-color: black;
}

#canvas-photo {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    max-height: 100%;
}

.img {
    position: relative;
}

.container-buttons {
    background: linear-gradient(#cdd7d6, white);
    width: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    right: 0px;
    height: 60px;
    min-height: 60px;
    padding-left: 7%;
    padding-right: 7%;
}

.buttons {
    width: 100px;
    margin-right: 0%;
}

#select-icon {
    font-size: 16px;
}

.btn-red {
    background-color: #f44336;
}

.btn-purple {
    background-color: #7e57c2;
}

.btn-yellow {
    background-color: #f9a825;
}

.btn-blue {
    background-color: #2979ff;
}

.btn-green {
    background-color: #43a047;
}

@media screen and (orientation: portrait) {
    #photo {
        width: 100%;
        height: auto;
    }
}

@media screen and (orientation: landscape) {
    #photo {
        width: auto;
        height: 100%;
    }
}
</style>
